export default __webpack_public_path__ + "static/media/microsoft-teams.b0064311.svg";